import React from "react";
import { Route, useRouteMatch } from "react-router-dom";

import PageBlockchainTransactions from "../pages/blockchain-transactions";

const RouteTransactions = () => {
  const { path } = useRouteMatch();

  return (
    <Route exact path={path}>
      <PageBlockchainTransactions />
    </Route>
  );
};

export default RouteTransactions;
